/**
 * A short check slide at the end of a lesson: one inline check question (answer until
 * right, not scored). Option ids are `<slide>-q-a`, `<slide>-q-b`, ... in the order given.
 */

import type { QuizTopic, Slide, SlideTone, Text } from "@/features/training/types";

/** One answer: its text, whether it is the right one, and the feedback shown for it. */
type Answer = readonly [text: Text, correct: boolean, fb: Text];

export function checkSlide(input: {
  id: string;
  tone: SlideTone;
  title: Text;
  topic: QuizTopic;
  stem: Text;
  answers: readonly Answer[];
  check: Text;
  labels?: string[];
}): Slide {
  return {
    id: input.id,
    tone: input.tone,
    title: input.title,
    job: "Click the right option to finish the module.",
    interaction: {
      id: `${input.id}-check`,
      kind: "check",
      required: true,
      question: {
        id: `${input.id}-q`,
        topic: input.topic,
        stem: input.stem,
        options: input.answers.map(([text, correct, fb], index) => ({
          id: `${input.id}-q-${String.fromCharCode(97 + index)}`,
          text,
          correct,
          fb,
        })),
      },
    },
    check: input.check,
    ...(input.labels ? { labels: input.labels } : {}),
  };
}
